import { Route, Routes } from "react-router-dom";
import { Routes as MarketplaceRoutes } from "./routes";
import { MarketplaceRouterCmp } from "./types";
import { MarketplaceSearchPage, MarketplaceDetailPage } from "../pages";

const MarketplaceRouter: MarketplaceRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={MarketplaceSearchPage.route}
          element={<MarketplaceSearchPage />}
        />
        <Route
          path={MarketplaceDetailPage.route}
          element={<MarketplaceDetailPage />}
        />
      </Routes>
    </>
  );
};

MarketplaceRouter.route = MarketplaceRoutes.MarketplaceRouter;

export default MarketplaceRouter;
